import styled from "styled-components";

export const SourcesContainer = styled.div`
  margin-bottom: 16px;
  margin-top: 5px;
`;

export const SourcesStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SourcesList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #e2e8f0;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #293778;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #1e2654;
  }
`;

export const SourceItem = styled.div<{ selected: boolean }>`
  padding: 16px;
  border: 1px solid ${(props) => (props.selected ? "#293778" : "#e2e8f0")};
  border-radius: 6px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.1s ease;
  background-color: ${(props) =>
    props.selected ? "rgba(41, 55, 120, 0.05)" : "white"};

  &:hover {
    background-color: ${(props) =>
      props.selected ? "rgba(41, 55, 120, 0.05)" : "#f8fafc"};
  }
`;

export const SourceItemContent = styled.div`
  display: flex;
  align-items: center;
`;

export const SourceItemText = styled.div`
  margin-left: 8px;
  font-weight: 500;
  color: #1e293b;
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  display: flex;
  align-items: center;
`;

export const StyledBadge = styled.div<{ backgroundColor: string }>`
  height: 20px;
  min-width: 80px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor || "#9E9E9E"};
  padding: 0 8px;

  & > span {
    font-size: 0.75rem;
    font-weight: 500;
    color: white;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;
  }
`;
